import { render, staticRenderFns } from "./CategoryPage.vue?vue&type=template&id=0bf47a1c"
import script from "./CategoryPage.vue?vue&type=script&lang=js"
export * from "./CategoryPage.vue?vue&type=script&lang=js"
import style0 from "./CategoryPage.vue?vue&type=style&index=0&id=0bf47a1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports